import { isEmpty } from "lodash-es";
import { Injectable } from "@angular/core";
import { SubjectModelSchema } from "../../_offline/models/subjectModel.schema";
import { SubjectLocation, SubjectModel } from "../../_objects/subject-model";
import { UtilsService } from "../_utils.service";

@Injectable({
  providedIn: "root"
})
export class SubjectLocationOfflineService {

  constructor(private utils : UtilsService) {}

  /**
   * Returns a matching location from the list of leafLocations based on the provided folderName and/or locationName.
   * Priority is given to 'locationIdentifer' if it is not null or empty; otherwise, 'folderName' is used.
   */
  public getImageSubjectLocation(subjectModelSchema: SubjectModelSchema, folderName: string, locationIdentifier?: string,): SubjectLocation | undefined {
    const subjectModel = new SubjectModel();
    subjectModel.setSubjectModelSchema(subjectModelSchema);

    const leafLocations: SubjectLocation[] = this.utils.getLocations(subjectModel, null);

    let match: SubjectLocation | undefined;

    if (locationIdentifier) {
      match = leafLocations.find(location => location.identifier === locationIdentifier);
    } else if (folderName) {
      match = leafLocations.find(location => location.folderName === folderName);
    }

    return match;
  }

}
